import _extends from "@babel/runtime/helpers/extends";
import { createContext, useContext } from 'react';
export var initialState = {};
export var PointerContext = /*#__PURE__*/createContext(initialState);
export var PointerDispatchContext = /*#__PURE__*/createContext(() => {});
export function reducer(tasks, action) {
  if (action && Object.keys(action).length === 0) return initialState;
  return _extends({}, tasks, action);
}
export var useStore = () => {
  return useContext(PointerContext);
};
export var useDispatch = () => {
  return useContext(PointerDispatchContext);
};